export interface MenuResponse {
  menuGroups: IMenu[]
}

export interface IMenu {
  name: string
  displayName: string
  url: string
  menuId: string
  menuItems: IMenuItem[]
  hidden?: boolean
}

export interface IMenuItem {
  name: string
  displayName: string
  url: string
}

export enum MenuNameEnum {
  dashboard = 'dashboard',
  economy = 'economy',
  communication = 'communication',
  boardwork = 'boardwork',
  housingcoop = 'housingcoop',
  housingcoopDk = 'housingcoop-dk',
  housebuildingcoop = 'housebuildingcoop',
  settings = 'settings',
  sustainability = 'sustainability',
  janitor = 'janitor',
  auditor = 'auditor',
}

export enum MenuItemNameEnum {
  // Quite incomplete
  portalusers = 'communication-portalusers',
}

export enum MenuTypeEnum {
  board = 'board',
  janitor = 'vaktmester',
  auditor = 'revisor',
}

export enum PortalTypeEnum {
  Styreportal,
  Vakmesterportal,
  Revisorportal,
  Eierportal,
  Signeringsportal,
}
